<template>
  <v-card outlined>
    <v-card-title
      >Schedule Definition
      <v-btn icon style="margin-left: 5px;" @click="showSchedulePicker = true">
        <v-icon small color="blue">mdi-pencil</v-icon>
      </v-btn>
    </v-card-title>
    <v-simple-table>
      <tbody>
        <tr>
          <td>
            <span style="color:grey">Schedule Description</span>
          </td>
          <td>{{ this.explanation }}</td>
        </tr>
        <tr>
          <td>
            <span style="color:grey">Cron Expression</span>
          </td>
          <td>{{ this.innerValue }}</td>
        </tr>
        <tr>
          <td>
            <span style="color:grey">Next Dates</span>
          </td>
          <td>
            <template v-for="scheduleEvent in nextEvents">
              <span :key="scheduleEvent"> {{ scheduleEvent }}<br /></span>
            </template>
          </td>
        </tr>
      </tbody>
    </v-simple-table>
    <v-dialog max-width="700" persistent v-model="showSchedulePicker">
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="showSchedulePicker = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Define Schedule</v-toolbar-title>
        </v-toolbar>
        <v-container>
          <v-toolbar flat>
            <v-btn-toggle
              v-model="scheduleMode"
              mandatory
              @change="displayScheduleMode"
            >
              <v-btn value="date">
                Single Date
              </v-btn>
              <v-btn value="hourly">
                Hourly
              </v-btn>
              <v-btn value="daily">
                Daily
              </v-btn>
              <v-btn value="weekly">
                Weekly
              </v-btn>
              <v-btn value="monthly">
                Monthly
              </v-btn>
              <v-btn value="custom">
                Custom
              </v-btn>
            </v-btn-toggle>
          </v-toolbar>
          <v-card-text>
            <v-container v-if="displayMap.singleDate">
              <div class="d-flex flex-row mb-6">
                <span class="pa-5">
                  On
                </span>
                <span>
                  <v-text-field
                    label="Schedule Date"
                    v-model="pickedDate"
                    @click="showDatePicker = true"
                    prepend-icon="mdi-calendar"
                  ></v-text-field>
                </span>

                <span class="pa-5">
                  at
                </span>
                <span>
                  <v-text-field
                    label="Time"
                    v-model="pickedTime"
                    type="time"
                    suffix="UTC"
                    prepend-icon="mdi-clock"
                    @click:prepend="showTimePicker = true"
                    @click="showTimePicker = true"
                  ></v-text-field>
                </span>
              </div>
            </v-container>
            <v-container v-if="displayMap.hourly">
              <div class="d-flex flex-row mb-6">
                <span class="pa-5">
                  Every
                </span>
                <span>
                  <v-text-field
                    label="Rate"
                    value="1"
                    type="number"
                    min="1"
                    v-model="hourInterval"
                  ></v-text-field>
                </span>
                <span class="pa-5">
                  hour(s) at minute
                </span>
                <span>
                  <v-select
                    v-model="minutesSelect"
                    :items="minutesItems"
                    :label="minutesSelect.length < 1 ? 'Select minute' : ''"
                  ></v-select>
                </span>
              </div>
            </v-container>
            <v-container v-if="displayMap.daily">
              <div class="d-flex flex-row mb-6">
                <span class="pa-5">
                  Every
                </span>
                <span>
                  <v-text-field
                    label="Rate"
                    value="1"
                    type="number"
                    min="1"
                    v-model="dayInterval"
                  ></v-text-field>
                </span>
                <span class="pa-5">
                  day(s) at
                </span>
                <span>
                  <v-text-field
                    label="Time"
                    v-model="pickedTime"
                    type="time"
                    suffix="UTC"
                    prepend-icon="mdi-clock"
                    @click:prepend="showTimePicker = true"
                    @click="showTimePicker = true"
                  ></v-text-field>
                </span>
              </div>
            </v-container>
            <v-container v-if="displayMap.weekly">
              <div class="d-flex flex-row mb-6">
                <span class="pa-5">
                  Every
                </span>
                <span>
                  <v-select
                    v-model="weekdaySelect"
                    :items="weekdayItems"
                    :label="weekdaySelect.length < 1 ? 'Select weekdays' : ''"
                    multiple
                  ></v-select>
                </span>
                <span class="pa-5">
                  at
                </span>
                <span>
                  <v-text-field
                    label="Time"
                    v-model="pickedTime"
                    type="time"
                    suffix="UTC"
                    prepend-icon="mdi-clock"
                    @click:prepend="showTimePicker = true"
                    @click="showTimePicker = true"
                  ></v-text-field>
                </span>
              </div>
            </v-container>
            <v-container v-if="displayMap.monthly">
              <div class="d-flex flex-row mb-6">
                <span class="pa-5">
                  Every
                </span>
                <v-text-field
                  label="Rate"
                  value="1"
                  type="number"
                  min="1"
                  v-model="monthlyInterval"
                ></v-text-field>
                <span class="pa-5">
                  month(s) on day(s)
                </span>
                <span>
                  <v-select
                    v-model="monthdaySelect"
                    :items="monthdayItems"
                    :label="monthdaySelect.length < 1 ? 'Select day(s)' : ''"
                    multiple
                  ></v-select>
                </span>
                <span class="pa-5">
                  at
                </span>
                <span>
                  <v-text-field
                    label="Time"
                    v-model="pickedTime"
                    type="time"
                    suffix="UTC"
                    prepend-icon="mdi-clock"
                    @click:prepend="showTimePicker = true"
                    @click="showTimePicker = true"
                  ></v-text-field>
                </span>
              </div>
            </v-container>
            <v-container v-if="displayMap.custom">
              <v-text-field
                label="Custom Cron Expression"
                v-model="customExpression"
              ></v-text-field>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-btn @click="submit">Submit</v-btn>
          </v-card-actions>
        </v-container>
      </v-card>
      <DatePicker
        v-if="showDatePicker"
        @pick="setDate"
        @close="showDatePicker = false"
      ></DatePicker>
      <TimePicker
        v-if="showTimePicker"
        @pick="setTime"
        @close="showTimePicker = false"
      ></TimePicker>
    </v-dialog>
  </v-card>
</template>

<script>
import DatePicker from '../forms/DatePicker'
import TimePicker from '../forms/TimePicker'
import moment from 'moment'
import cronParser from 'aws-cron-parser'
import vueCronEditorMixin from './core/vueCronEditorMixin'

export default {
  name: 'CloudWatchCronExpressionBuilder',
  mixins: [vueCronEditorMixin],
  props: ['showNextEvents'],
  data: () => ({
    scheduleMode: 'date',
    displayMap: {
      singleDate: true,
      daily: false,
      weekly: false,
      monthly: false,
      custom: false
    },
    showSchedulePicker: true,
    showDatePicker: false,
    pickedDate: '',
    showTimePicker: false,
    pickedTime: '',
    hourInterval: '1',
    minutesSelect: [],
    minutesItems: [...Array(59).keys()].map(num => {
      return { text: (num + 1).toString(), value: num + 1 }
    }),
    dayInterval: '1',
    nextEvents: [],
    customExpression: '',
    weekdaySelect: [],
    weekdayItems: [
      { text: 'Monday', value: 2 },
      { text: 'Tuesday', value: 3 },
      { text: 'Wednesday', value: 4 },
      { text: 'Thursday', value: 5 },
      { text: 'Friday', value: 6 },
      { text: 'Saturday', value: 7 },
      { text: 'Sunday', value: 1 }
    ],
    monthdaySelect: [],
    monthdayItems: [...Array(31).keys()]
      .map(num => {
        return { text: (num + 1).toString(), value: num + 1 }
      })
      .concat([{ text: 'Last', value: 'L' }]),
    monthlyInterval: '1'
  }),
  components: {
    DatePicker,
    TimePicker
  },
  watch: {
    innerValue(val) {
      this.calculateNextEvents(val)
    }
  },
  methods: {
    displayScheduleMode() {
      this.displayMap = {
        singleDate: this.scheduleMode === 'date',
        hourly: this.scheduleMode === 'hourly',
        daily: this.scheduleMode === 'daily',
        weekly: this.scheduleMode === 'weekly',
        monthly: this.scheduleMode === 'monthly',
        custom: this.scheduleMode === 'custom'
      }
    },
    setDate(data) {
      this.showDatePicker = false
      this.pickedDate = data
    },
    setTime(data) {
      this.showTimePicker = false
      this.pickedTime = data
    },
    calculateNextEvents(expression) {
      this.nextEvents = []
      try {
        let cron = cronParser.parse(expression)
        if (cron !== undefined) {
          let occasion = new Date()
          for (let i = 0; occasion !== null && i < this.showNextEvents; i++) {
            occasion = cronParser.next(cron, occasion)
            this.nextEvents.push(occasion.toUTCString())
          }
        }
      } catch (e) {}
    },
    submit() {
      this.mapScheduleDefinition()
      this.showSchedulePicker = false
      this.$emit('input', this.innerValue)
    },
    mapScheduleDefinition() {
      const collectDateInputs = function(date, time) {
        let scheduleDate = new Date(date + ' ' + time)
        return {
          type: 'date',
          minutes: scheduleDate.getMinutes(),
          hours: scheduleDate.getHours(),
          day: scheduleDate.getDate(),
          month: scheduleDate.getMonth() + 1,
          year: scheduleDate.getFullYear()
        }
      }

      const collectHourlyInputs = function(hourInterval, minutesSelect) {
        return {
          type: 'hourly',
          minutes: minutesSelect,
          hourInterval: hourInterval
        }
      }

      const collectDailyInputs = function(dayInterval, time) {
        let scheduleDate = new Date('2020-01-01 ' + time)
        return {
          type: 'daily',
          minutes: scheduleDate.getMinutes(),
          hours: scheduleDate.getHours(),
          dayInterval: dayInterval
        }
      }

      const collectWeeklyInputs = function(weekdaySelect, time) {
        let scheduleDate = new Date('2020-01-01 ' + time)
        return {
          type: 'weekly',
          minutes: scheduleDate.getMinutes(),
          hours: scheduleDate.getHours(),
          days: weekdaySelect
        }
      }

      const collectMonthlyInputs = function(
        monthlyInterval,
        monthdaySelect,
        time
      ) {
        let scheduleDate = new Date('2020-01-01 ' + time)
        return {
          type: 'monthly',
          minutes: scheduleDate.getMinutes(),
          hours: scheduleDate.getHours(),
          days: monthdaySelect,
          monthInterval: monthlyInterval
        }
      }

      const collectCustomInputs = function(expression) {
        return {
          type: 'custom',
          cronExpression: expression
        }
      }

      let scheduleModeMap = {
        custom: collectCustomInputs(this.customExpression),
        date: collectDateInputs(this.pickedDate, this.pickedTime),
        hourly: collectHourlyInputs(this.hourInterval, this.minutesSelect),
        daily: collectDailyInputs(this.dayInterval, this.pickedTime),
        weekly: collectWeeklyInputs(this.weekdaySelect, this.pickedTime),
        monthly: collectMonthlyInputs(
          this.monthlyInterval,
          this.monthdaySelect,
          this.pickedTime
        )
      }

      this.$data.editorData = Object.assign(
        {},
        scheduleModeMap[this.scheduleMode]
      )
    },
    close() {
      this.$emit('close')
    },
    formatDate: function(date) {
      return moment
        .utc(date)
        .local()
        .format('DD.MM.YY, HH:mm:ss')
    }
  }
}
</script>

<style scoped></style>
